<template>
  <div>
    <!--<h5 class="lead mt-4">Controle do Fluxo da Proposta</h5>
    <hr style="margin-top:8px;" />-->
    <!-- Risk Assessment controls -->
    <b-row class="d-flex justify-content-between align-items-center my-4">
      <b-col md="3">
        <b-form-checkbox
          switch
          size="sm"
          v-model="proposal.steps.riskAssessment.actived"
          >Avaliação de Risco</b-form-checkbox
        >
      </b-col>
      <b-col md="3">
        <b-form-select
          size="sm"
          v-model="proposal.steps.riskAssessment.situation"
          :options="riskAssessmentSituationOptions"
          v-if="proposal.steps.riskAssessment.actived"
          @change="riskAssessmentSituationChange"
        ></b-form-select>
      </b-col>
      <b-col md="3">
        <b-form-select
          size="sm"
          v-model="proposal.steps.riskAssessment.status"
          v-if="
            riskAssessmentStatusOptions[proposal.steps.riskAssessment.situation]
          "
          :options="
            riskAssessmentStatusOptions[proposal.steps.riskAssessment.situation]
          "
        ></b-form-select>
      </b-col>
      <b-col md="3">
        <b-form-datepicker
          size="sm"
          placeholder="Data de validade"
          locale="pt-BR"
          :value-as-date="false"
          :date-format-options="{
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }"
          v-model="proposal.steps.riskAssessment.dueDate"
          v-if="proposal.steps.riskAssessment.status"
        >
        </b-form-datepicker>
      </b-col>
    </b-row>
    <!-- Engineering controls -->
    <b-row class="d-flex justify-content-between align-items-center mb-4">
      <b-col md="3">
        <b-form-checkbox
          switch
          size="sm"
          v-model="proposal.steps.engineering.actived"
          >Engenharia</b-form-checkbox
        >
      </b-col>
      <b-col md="3">
        <b-form-select
          size="sm"
          v-model="proposal.steps.engineering.situation"
          :options="engineeringSituationOptions"
          v-if="proposal.steps.engineering.actived"
        ></b-form-select>
      </b-col>
      <b-col md="3">
        <b-form-select
          size="sm"
          v-model="proposal.steps.engineering.status"
          v-if="engineeringStatusOptions[proposal.steps.engineering.situation]"
          :options="
            engineeringStatusOptions[proposal.steps.engineering.situation]
          "
        ></b-form-select>
      </b-col>
      <b-col md="3">
        <b-form-datepicker
          size="sm"
          placeholder="Data de validade"
          locale="pt-BR"
          today-button
          reset-button
          close-button
          :date-format-options="{
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }"
          v-model="proposal.steps.engineering.dueDate"
          v-if="proposal.steps.engineering.situation"
        >
        </b-form-datepicker>
      </b-col>
    </b-row>
    <!-- Forms controls -->
    <b-row class="d-flex justify-content-between align-items-center mb-4">
      <b-col md="3">
        <b-form-checkbox switch size="sm" v-model="proposal.steps.forms.actived"
          >Formulários</b-form-checkbox
        >
      </b-col>
      <b-col md="3">
        <b-form-select
          size="sm"
          v-model="proposal.steps.forms.situation"
          :options="formsSituationOptions"
          v-if="proposal.steps.forms.actived"
        ></b-form-select>
      </b-col>
      <b-col md="3">
        <b-form-select
          size="sm"
          v-model="proposal.steps.forms.status"
          v-if="formsStatusOptions[proposal.steps.forms.situation]"
          :options="formsStatusOptions[proposal.steps.forms.situation]"
          @change="formStatusChange"
        ></b-form-select>
      </b-col>
      <b-col md="3">
        <b-form-datepicker
          size="sm"
          placeholder="Data de validade"
          locale="pt-BR"
          today-button
          reset-button
          close-button
          :date-format-options="{
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }"
          v-model="proposal.steps.forms.dueDate"
          v-if="proposal.steps.forms.situation"
        >
        </b-form-datepicker>
      </b-col>
    </b-row>
    <!-- FGTS controls -->
    <b-row
      class="d-flex justify-content-between align-items-center mb-4"
      v-if="proposal.fgts"
    >
      <b-col md="3">
        <b-form-checkbox switch size="sm" v-model="proposal.steps.fgts.actived"
          >FGTS</b-form-checkbox
        >
      </b-col>
      <b-col md="3">
        <b-form-select
          size="sm"
          v-model="proposal.steps.fgts.situation"
          :options="fgtsSituationOptions"
          v-if="proposal.steps.fgts.actived"
        ></b-form-select>
      </b-col>
      <b-col md="3">
        <b-form-select
          size="sm"
          v-model="proposal.steps.fgts.status"
          v-if="fgtsStatusOptions[proposal.steps.fgts.situation]"
          :options="fgtsStatusOptions[proposal.steps.fgts.situation]"
        ></b-form-select>
      </b-col>
      <b-col md="3">
        <b-form-datepicker
          size="sm"
          placeholder="Data de validade"
          locale="pt-BR"
          today-button
          reset-button
          close-button
          :date-format-options="{
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }"
          v-model="proposal.steps.fgts.dueDate"
          v-if="proposal.steps.fgts.situation"
        >
        </b-form-datepicker>
      </b-col>
    </b-row>
    <!-- SIOPI controls -->
    <b-row class="d-flex justify-content-between align-items-center mb-4">
      <b-col md="3">
        <b-form-checkbox switch size="sm">SIOPI</b-form-checkbox>
      </b-col>
      <b-col md="3">
        <b-form-select
          size="sm"
          v-model="proposal.steps.dossier.situation"
          :options="siopiSituationOptions"
        ></b-form-select>
      </b-col>
      <b-col md="3"> </b-col>
      <b-col md="3">
        <b-form-datepicker
          size="sm"
          placeholder="Data de validade"
          locale="pt-BR"
          today-button
          reset-button
          close-button
          :date-format-options="{
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }"
          v-if="proposal.steps.dossier.situation"
        >
        </b-form-datepicker>
      </b-col>
    </b-row>
    <!-- Dossier controls -->
    <b-row class="d-flex justify-content-between align-items-center mb-4">
      <b-col md="3">
        <b-form-checkbox
          switch
          size="sm"
          v-model="proposal.steps.dossier.actived"
          >Dossiê</b-form-checkbox
        >
      </b-col>
      <b-col md="3">
        <b-form-select
          size="sm"
          v-model="proposal.steps.dossier.situation"
          :options="dossierSituationOptions"
          v-if="proposal.steps.dossier.actived"
        ></b-form-select>
      </b-col>
      <b-col md="3"> </b-col>
      <b-col md="3">
        <b-form-datepicker
          size="sm"
          placeholder="Data de validade"
          locale="pt-BR"
          today-button
          reset-button
          close-button
          :date-format-options="{
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }"
          v-model="proposal.steps.dossier.dueDate"
          v-if="proposal.steps.dossier.situation"
        >
        </b-form-datepicker>
      </b-col>
    </b-row>
    <!-- Contract controls -->
    <b-row class="d-flex justify-content-between align-items-center mb-4">
      <b-col md="3">
        <b-form-checkbox
          switch
          size="sm"
          v-model="proposal.steps.contract.actived"
          >Escritura</b-form-checkbox
        >
      </b-col>
      <b-col md="3">
        <b-form-select
          size="sm"
          v-model="proposal.steps.contract.situation"
          :options="contractSituationOptions"
          v-if="proposal.steps.contract.actived"
        ></b-form-select>
      </b-col>
      <b-col md="3">
        <b-form-select
          size="sm"
          v-model="proposal.steps.contract.status"
          v-if="contractStatusOptions[proposal.steps.contract.situation]"
          :options="contractStatusOptions[proposal.steps.contract.situation]"
        ></b-form-select>
        <br />
      </b-col>
      <b-col md="3">
        <b-form-datepicker
          size="sm"
          placeholder="Data de validade"
          locale="pt-BR"
          today-button
          reset-button
          close-button
          :date-format-options="{
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }"
          v-model="proposal.steps.contract.dueDate"
          v-if="proposal.steps.contract.status"
        >
        </b-form-datepicker>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
var moment = require("moment");
moment.locale("pt-br");

var bootbox = require("bootbox");

export default {
  name: "ControlOfTheProposalFlow",
  data() {
    return {
      array: "",
      riskAssessmentSituationOptions: [
        {
          value: "",
          text: "Selecione a situação",
          color: "light",
          msg: "",
          progress: 0,
        },
        {
          value: "Em análise",
          text: "Em análise",
          color: "secondary",
          msg: "Aguardando análise da documentação em",
          progress: 2,
        },
        {
          value: "Analisado",
          text: "Analisado",
          color: "BadgeColor Aqui",
          msg: "Msg Aqui",
          progress: 0,
        },
      ],
      riskAssessmentStatusOptions: {
        Analisado: [
          {
            value: "",
            text: "Selecione o status",
            color: "light",
            msg: "",
            progress: 0,
          },
          {
            value: "Aprovado",
            text: "Aprovado",
            color: "success",
            msg: "Avaliação de risco aprovada em",
            progress: 30,
          },
          {
            value: "Condicionado",
            text: "Condicionado",
            color: "info",
            msg: "Avaliação de risco condicionada em",
            progress: 30,
          },
          {
            value: "Reprovada",
            text: "Reprovada",
            color: "danger",
            msg: "Avaliação de risco reprovada em",
            progress: 0,
          },
          {
            value: "Com restrição",
            text: "Com restrição",
            color: "warning",
            msg: "Participante(s) com restrição em",
            progress: 5,
          },
          {
            value: "Com pendência(s)",
            text: "Com pendência(s)",
            color: "warning",
            msg: "Proposta apresenta pendência(s) documental em",
            progress: 5,
          },
          {
            value: "Com restrição e Com pendência(s)",
            text: "Com restrição e Com pendência(s)",
            color: "warning",
            msg: "Proposta com pendência(s) e restrição cadastral em",
            progress: 5,
          },
        ],
      },
      engineeringSituationOptions: [
        {
          value: "",
          text: "Selecione a situação",
          color: "light",
          msg: "",
          progress: 0,
        },
        {
          value: "Boleto",
          text: "Boleto",
          color: "secondary",
          msg: "Boleto de engenharia enviado para pagamento em",
          progress: 5,
        },
        {
          value: "Convocada",
          text: "Convocada",
          color: "info",
          msg: "O.S. de engenharia convocada em",
          progress: 13,
        },
        {
          value: "Emitida",
          text: "Emitida",
          color: "primary",
          msg: "O.S. de engenharia emitida em",
          progress: 15,
        },
        { value: "Laudo", text: "Laudo", color: "", msg: "", progress: 0 },
      ],
      engineeringStatusOptions: {
        Laudo: [
          {
            value: "",
            text: "Selecione o status",
            color: "light",
            msg: "",
            progress: 0,
          },
          {
            value: "Válido",
            text: "Válido",
            color: "success",
            msg: "Imóvel aceito como garantia em",
            progress: 25,
          },
          {
            value: "Inválido",
            text: "Inválido",
            color: "danger",
            msg: "Imóvel não aceito como garantia em",
            progress: 5,
          },
          {
            value: "Pept",
            text: "Pept",
            color: "warning",
            msg: "Imóvel aguardando cumprimento de exigência em",
            progress: 21,
          },
        ],
      },
      formsSituationOptions: [
        {
          value: "",
          text: "Selecione a situação",
          color: "light",
          msg: "",
          progress: 0,
        },
        {
          value: "Emitidos",
          text: "Emitidos",
          color: "secondary",
          msg: "Formulários preparados para envio ao cliente em",
          progress: 1,
        },
        {
          value: "Enviados",
          text: "Enviados",
          color: "warning",
          msg: "Formulários enviados ao cliente em",
          progress: 2,
        },
        {
          value: "Recebidos",
          text: "Recebidos",
          color: "",
          msg: "Formulários recebidos à conferir em",
          progress: 0,
        },
      ],
      formsStatusOptions: {
        Recebidos: [
          {
            value: "",
            text: "Selecione o status",
            color: "light",
            msg: "",
            progress: 0,
          },
          {
            value: "Inconforme",
            text: "Inconforme",
            color: "danger",
            msg: "Formulários recebidos e com exigência(s) em",
            progress: 2,
          },
          {
            value: "À carimbar",
            text: "À carimbar",
            color: "primary",
            msg: "Formulários recebidos à carimbar em",
            progress: 5,
          },
          {
            value: "Carimbados",
            text: "Carimbados",
            color: "success",
            msg: "Formulários recebidos e carimbados em",
            progress: 6,
          },
        ],
      },
      fgtsSituationOptions: [
        {
          value: "",
          text: "Selecione a situação",
          color: "light",
          msg: "",
          progress: 0,
        },
        {
          value: "Cadastrado",
          text: "Cadastrado",
          color: "secondary",
          msg: "Operação de FGTS cadastrada para débito em",
          progress: 2,
        },
        {
          value: "Solicitado",
          text: "Solicitado",
          color: "",
          msg: "",
          progress: 0,
        },
      ],
      fgtsStatusOptions: {
        Solicitado: [
          {
            value: "",
            text: "Selecione o status",
            color: "light",
            msg: "",
            progress: 0,
          },
          {
            value: "Liberação de ressarcimento solicitada",
            text: "Liberação de ressarcimento solicitada em",
            color: "primary",
            msg: "Débito do FGTS aguardando ressarcimento",
            progress: 10,
          },
          {
            value: "Com erro",
            text: "Com erro",
            color: "danger",
            msg: "Operação de FGTS com exigência(s) em",
            progress: 5,
          },
          {
            value: "Ressarcida",
            text: "Ressarcida",
            color: "success",
            msg: "Operação de FGTS ressarcida em",
            progress: 15,
          },
        ],
      },
      siopiSituationOptions: [
        {
          value: "",
          text: "Selecione a situação",
          color: "light",
          msg: "",
          progress: 0,
        },
        {
          value: "Em andamento",
          text: "Em andamento",
          color: "secondary",
          msg: "SIOPI em andamento.",
          progress: 1,
        },
        {
          value: "Pendente de encaminhar",
          text: "Pendente de encaminhar",
          color: "primary",
          msg: "SIOPI concluído, pendente de encaminhar.",
          progress: 2,
        },
        {
          value: "Encaminhado",
          text: "Encaminhado",
          color: "success",
          msg: "SIOPI encaminhado.",
          progress: 3,
        },
      ],
      dossierSituationOptions: [
        {
          value: "",
          text: "Selecione a situação",
          color: "light",
          msg: "",
          progress: 0,
        },
        {
          value: "Em montagem",
          text: "Em montagem",
          color: "secondary",
          msg: "Dossiê em montagem para entrega em",
          progress: 1,
        },
        {
          value: "Montado",
          text: "Montado",
          color: "primary",
          msg: "Dossiê montado para envio à agência em",
          progress: 2,
        },
        {
          value: "Entregue",
          text: "Entregue",
          color: "success",
          msg: "Dossiê entregue a agência em",
          progress: 3,
        },
      ],
      contractSituationOptions: [
        {
          value: "",
          text: "Selecione a situação",
          color: "light",
          msg: "",
          progress: 0,
        },
        {
          value: "Em análise de conformidade",
          text: "Em análise de conformidade",
          color: "secondary",
          msg: "",
          progress: 0,
        },
        {
          value: "Emitida",
          text: "Emitida",
          color: "light",
          msg: "",
          progress: 0,
        },
      ],
      contractStatusOptions: {
        "Em análise de conformidade": [
          {
            value: "",
            text: "Selecione o status",
            color: "light",
            msg: "",
            progress: 0,
          },
          {
            value: "Enviando",
            text: "Enviando",
            color: "secondary",
            msg: "Dossiê em montagem no SICTD em",
            progress: 4,
          },
          {
            value: "Enviado",
            text: "Enviado",
            color: "warning",
            msg: "Proposta em análise da conformidade em",
            progress: 6,
          },
          {
            value: "Conforme",
            text: "Conforme",
            color: "primary",
            msg: "Proposta conforme para emissão da escritura em",
            progress: 10,
          },
          {
            value: "Com exigência",
            text: "Com exigência",
            color: "danger",
            msg: "Proposta em cumprimento de exigência(s) em ",
            progress: 4,
          },
          {
            value: "Reenviada",
            text: "Reenviada",
            color: "info",
            msg: "Proposta reeviada para análise da conformidade em",
            progress: 8,
          },
        ],
        Emitida: [
          {
            value: "",
            text: "Selecione o status",
            color: "light",
            msg: "",
            progress: 0,
          },
          {
            value: "Agendada",
            text: "Agendada",
            color: "warning",
            msg: "Escritura agendada para",
            progress: 10,
          },
          {
            value: "Contratada",
            text: "Contratada",
            color: "primary",
            msg: "Escritura contratada em",
            progress: 14,
          },
          {
            value: "Evoluída",
            text: "Evoluída",
            color: "success",
            msg: "Escritura evoluída em",
            progress: 15,
          },
        ],
      },
      selectedProposal: this.$store.state.proposal,
    };
  },
  methods: {
    ...mapMutations(["setModificationNotification"]),
    ...mapActions(["getProposal"]),
    /*formStatusChange(val) {
      if (
        this.proposal.steps.forms.situation == "Recebidos" &&
        val === "À carimbar" &&
        this.selectedProposal.steps.forms.status !== val
      ) {
        this.setModificationNotification({
          type: "modified",
          created_by: this.user.uid,
          proposalName: this.proposal.name,
          id: this.proposal.id,
          text:
            "Formulários recebidos conforme. Carimbe os formulários para inclusão no SICTD.",
        });
      }
    },*/
    /*riskAssessmentSituationChange(val) {
      if (
        val === "Em análise" &&
        this.selectedProposal.steps.riskAssessment.situation != val
      ) {
        this.setModificationNotification({
          type: "modified",
          created_by: this.user.uid,
          proposalName: this.proposal.name,
          id: this.proposal.id,
          text: "Proposta em análise. Verificar avaliação de risco",
        });
      }
    },*/
  },
  computed: {
    ...mapState(["proposal", "user"]),
  },
  watch: {
    "proposal.steps.riskAssessment.situation"(newVal, oldVal) {
      // if (oldVal && newVal !== oldVal) {
      //   this.proposal.steps.riskAssessment.status = "";
      // }
      if (newVal) {
        for (let key in this.riskAssessmentSituationOptions) {
          if (newVal === this.riskAssessmentSituationOptions[key].value) {
            this.proposal.steps.riskAssessment.color = this.riskAssessmentSituationOptions[
              key
            ].color;
            this.proposal.steps.riskAssessment.note = this.riskAssessmentSituationOptions[
              key
            ].msg;
            this.proposal.steps.riskAssessment[
              "progress"
            ] = this.riskAssessmentSituationOptions[key].progress;
          }
        }
      } else {
        this.proposal.steps.riskAssessment.color = "light";
        this.proposal.steps.riskAssessment.note = "";
        this.proposal.steps.riskAssessment.progress = 0;
      }
    },
    "proposal.steps.riskAssessment.status"(newVal) {
      if (newVal) {
        let situationArr = this.riskAssessmentStatusOptions[
          this.proposal.steps.riskAssessment.situation
        ];
        situationArr.forEach((situation) => {
          if (situation.value === newVal) {
            if (situation.color)
              this.proposal.steps.riskAssessment.color = situation.color;
            if (situation.msg)
              this.proposal.steps.riskAssessment.note = situation.msg;
            if (situation.progress)
              this.proposal.steps.riskAssessment.progress = situation.progress;
          }
        });
        if (
          (this.proposal.steps.riskAssessment.status == "Aprovado" &&
            this.proposal.steps.riskAssessment.dueDate == "") ||
          (this.proposal.steps.riskAssessment.status == "Condicionado" &&
            this.proposal.steps.riskAssessment.dueDate == "")
        ) {
          //if ( this.proposal.steps.riskAssessment.status == 'Aprovado' && this.proposal.approvedFinancingAmount == 0 || this.proposal.steps.riskAssessment.status == 'Condicionado' && this.proposal.approvedFinancingAmount == 0 ){
          this.$bvToast.toast(
            `Informe o valor aprovado e confira a data de validade da avaliação. ;)`,
            {
              title: "Eiiii... Lembrando!",
              variant: "primary",
              autoHideDelay: 2000,
            }
          );
          //this.$refs.operationValue.$el.focus();

          var today = new Date();
          var approvalValidity = moment(today)
            .add(180, "days")
            .format("YYYY-MM-DD");
          this.proposal.steps.riskAssessment.dueDate = approvalValidity;
        } //else {
        //var today = new Date();
        //var riskAssessmentDate = moment(today).format('YYYY-MM-DD')
        //this.proposal.steps.riskAssessment.dueDate = riskAssessmentDate;
        //}
      } else {
        for (let key in this.riskAssessmentSituationOptions) {
          if (
            this.proposal.steps.riskAssessment.situation ===
            this.riskAssessmentSituationOptions[key].value
          ) {
            this.proposal.steps.riskAssessment.color = this.riskAssessmentSituationOptions[
              key
            ].color;
            this.proposal.steps.riskAssessment.note = this.riskAssessmentSituationOptions[
              key
            ].msg;
            this.proposal.steps.riskAssessment.progress = this.riskAssessmentSituationOptions[
              key
            ].progress;
          }
        }
      }
    },
    "proposal.steps.engineering.situation"(newVal, oldVal) {
      // if (oldVal && newVal !== oldVal) {
      //   this.proposal.steps.engineering.status = "";
      // }
      if (
        newVal === "Emitida" &&
        newVal !== this.selectedProposal.steps.engineering.situation
      ) {
        this.setModificationNotification({
          type: "modified",
          created_by: this.user.uid,
          proposalName: this.proposal.name,
          id: this.proposal.id,
          text:
            "Engenharia emitida. Emitir formulários - Cadastro, Comercial (conta e cartão de crédito), se houver e MO29300.",
        });
      }
      if (oldVal || !this.proposal.steps.engineering.dueDate) {
        var today = new Date();
        var engineeringDate = moment(today).format("YYYY-MM-DD");
        this.proposal.steps.engineering.dueDate = engineeringDate;
      }
      if (newVal) {
        for (let key in this.engineeringSituationOptions) {
          if (newVal === this.engineeringSituationOptions[key].value) {
            this.proposal.steps.engineering.color = this.engineeringSituationOptions[
              key
            ].color;
            this.proposal.steps.engineering.note = this.engineeringSituationOptions[
              key
            ].msg;
            this.proposal.steps.engineering[
              "progress"
            ] = this.engineeringSituationOptions[key].progress;
          }
        }
      } else {
        this.proposal.steps.engineering.color = "light";
        this.proposal.steps.engineering.note = "";
        this.proposal.steps.engineering.progress = 0;
      }
    },
    "proposal.steps.engineering.status"(newVal, oldVal) {
      if (
        this.proposal.steps.engineering.situation === "Laudo" &&
        this.proposal.steps.engineering.status === "Válido" &&
        newVal !== this.selectedProposal.steps.engineering.status
      ) {
        if (this.proposal.fgts) {
          this.setModificationNotification({
            type: "modified",
            created_by: this.user.uid,
            proposalName: this.proposal.name,
            id: this.proposal.id,
            text: "Emitir DAMP",
          });
        }
        this.setModificationNotification({
          type: "modified",
          created_by: this.user.uid,
          proposalName: this.proposal.name,
          id: this.proposal.id,
          text: "Finalizar a proposta no SIOPI.",
        });
      }

      if (newVal) {
        let situationArr = this.engineeringStatusOptions[
          this.proposal.steps.engineering.situation
        ];
        situationArr.forEach((situation) => {
          if (situation.value === newVal) {
            if (situation.color)
              this.proposal.steps.engineering.color = situation.color;
            if (situation.msg)
              this.proposal.steps.engineering.note = situation.msg;
            if (situation.progress)
              this.proposal.steps.engineering.progress = situation.progress;
          }
        });
        if (
          this.proposal.steps.engineering.status == "Válido" &&
          this.proposal.engineeringEvaluation == 0
        ) {
          this.$bvToast.toast(
            `Informe o valor de avaliação da engenharia. ;)`,
            {
              title: "Eiiii... Lembrando!",
              variant: "primary",
              autoHideDelay: 2000,
            }
          );
          // this.$refs.engineeringEvaluation.$el.focus();
          if (oldVal || !this.proposal.steps.engineering.dueDate) {
            var today = new Date();
            var engineeringDate = moment(today).format("YYYY-MM-DD");
            this.proposal.steps.engineering.dueDate = engineeringDate;
          }
        }
        //  else {
        //   var today = new Date();
        //   var engineeringDate = moment(today).format("YYYY-MM-DD");
        //   this.proposal.steps.engineering.dueDate = engineeringDate;
        // }
      } else {
        for (let key in this.engineeringSituationOptions) {
          if (
            this.proposal.steps.engineering.situation ===
            this.engineeringSituationOptions[key].value
          ) {
            this.proposal.steps.engineering.color = this.engineeringSituationOptions[
              key
            ].color;
            this.proposal.steps.engineering.note = this.engineeringSituationOptions[
              key
            ].msg;
            this.proposal.steps.engineering.progress = this.engineeringSituationOptions[
              key
            ].progress;
          }
        }
      }
    },
    "proposal.steps.forms.situation"(newVal, oldVal) {
      if (oldVal || !this.proposal.steps.forms.dueDate) {
        var today = new Date();
        var formstDate = moment(today).format("YYYY-MM-DD");
        this.proposal.steps.forms.dueDate = formstDate;
      }
      if (newVal) {
        for (let key in this.formsSituationOptions) {
          if (newVal === this.formsSituationOptions[key].value) {
            this.proposal.steps.forms.color = this.formsSituationOptions[
              key
            ].color;
            this.proposal.steps.forms.note = this.formsSituationOptions[
              key
            ].msg;
            this.proposal.steps.forms["progress"] = this.formsSituationOptions[
              key
            ].progress;
          }
        }
      } else {
        this.proposal.steps.forms.color = "light";
        this.proposal.steps.forms.note = "";
        this.proposal.steps.forms.progress = 0;
      }
    },
    "proposal.steps.forms.status"(newVal, oldVal) {
      if (newVal) {
        let situationArr = this.formsStatusOptions[
          this.proposal.steps.forms.situation
        ];
        situationArr.forEach((situation) => {
          if (situation.value === newVal) {
            if (situation.color)
              this.proposal.steps.forms.color = situation.color;
            if (situation.msg) this.proposal.steps.forms.note = situation.msg;
            if (situation.progress)
              this.proposal.steps.forms.progress = situation.progress;
          }
        });
      } else {
        for (let key in this.formsSituationOptions) {
          if (
            this.proposal.steps.forms.situation ===
            this.formsSituationOptions[key].value
          ) {
            this.proposal.steps.forms.color = this.formsSituationOptions[
              key
            ].color;
            this.proposal.steps.forms.note = this.formsSituationOptions[
              key
            ].msg;
            this.proposal.steps.forms.progress = this.formsSituationOptions[
              key
            ].progress;
          }
        }
      }
      // var today = new Date();
      // var formstDate = moment(today).format("YYYY-MM-DD");
      // this.proposal.steps.forms.dueDate = formstDate;
    },
    "proposal.steps.fgts.situation"(newVal, oldVal) {
      // if (oldVal && newVal !== oldVal) {
      //   this.proposal.steps.fgts.status = "";
      //   console.log(this.proposal.steps.fgts.status, 'this.proposal.steps.fgts.status');
      // }
      if (oldVal || !this.proposal.steps.fgts.dueDate) {
        var today = new Date();
        var fgtsDate = moment(today).format("YYYY-MM-DD");
        this.proposal.steps.fgts.dueDate = fgtsDate;
      }
      if (newVal) {
        for (let key in this.fgtsSituationOptions) {
          if (newVal === this.fgtsSituationOptions[key].value) {
            this.proposal.steps.fgts.color = this.fgtsSituationOptions[
              key
            ].color;
            this.proposal.steps.fgts.note = this.fgtsSituationOptions[key].msg;
            this.proposal.steps.fgts["progress"] = this.fgtsSituationOptions[
              key
            ].progress;
          }
        }
      } else {
        this.proposal.steps.fgts.color = "light";
        this.proposal.steps.fgts.note = "";
        this.proposal.steps.fgts.progress = 0;
      }
    },
    "proposal.steps.fgts.status"(newVal, oldVal) {
      if (newVal) {
        let situationArr = this.fgtsStatusOptions[
          this.proposal.steps.fgts.situation
        ];
        situationArr.forEach((situation) => {
          if (situation.value === newVal) {
            if (situation.color)
              this.proposal.steps.fgts.color = situation.color;
            if (situation.msg) this.proposal.steps.fgts.note = situation.msg;
            if (situation.progress)
              this.proposal.steps.fgts.progress = situation.progress;
          }
        });
      } else {
        for (let key in this.fgtsSituationOptions) {
          if (
            this.proposal.steps.fgts.situation ===
            this.fgtsSituationOptions[key].value
          ) {
            this.proposal.steps.fgts.color = this.fgtsSituationOptions[
              key
            ].color;
            this.proposal.steps.fgts.note = this.fgtsSituationOptions[key].msg;
            this.proposal.steps.fgts.progress = this.fgtsSituationOptions[
              key
            ].progress;
          }
        }
      }
      if (oldVal || !this.proposal.steps.fgts.dueDate) {
        var today = new Date();
        var fgtsDate = moment(today).format("YYYY-MM-DD");
        this.proposal.steps.fgts.dueDate = fgtsDate;
      }
    },
    "proposal.steps.dossier.situation"(newVal, oldVal) {
      // if (oldVal && newVal !== oldVal) {
      //   this.proposal.steps.dossier.status = "";
      // }
      if (!this.proposal.steps.dossier.dueDate) {
        var today = new Date();
        var dossierDate = moment(today).format("YYYY-MM-DD");
        this.proposal.steps.dossier.dueDate = dossierDate;
      }
      if (newVal) {
        for (let key in this.dossierSituationOptions) {
          if (newVal === this.dossierSituationOptions[key].value) {
            this.proposal.steps.dossier.color = this.dossierSituationOptions[
              key
            ].color;
            this.proposal.steps.dossier.note = this.dossierSituationOptions[
              key
            ].msg;
            this.proposal.steps.dossier[
              "progress"
            ] = this.dossierSituationOptions[key].progress;
          }
        }
      } else {
        this.proposal.steps.dossier.color = "light";
        this.proposal.steps.dossier.note = "";
        this.proposal.steps.dossier.progress = 0;
      }
    },
    "proposal.steps.contract.situation"(newVal, oldVal) {
      // if (oldVal && newVal !== oldVal) {
      //   this.proposal.steps.contract.status = "";
      // }
      if (newVal) {
        for (let key in this.contractSituationOptions) {
          if (newVal === this.contractSituationOptions[key].value) {
            this.proposal.steps.contract.color = this.contractSituationOptions[
              key
            ].color;
            this.proposal.steps.contract.note = this.contractSituationOptions[
              key
            ].msg;
            this.proposal.steps.contract[
              "progress"
            ] = this.contractSituationOptions[key].progress;
          }
        }
        if (
          this.proposal.steps.contract.situation != "" &&
          this.proposal.operationValue == 0 &&
          oldVal
        ) {
          this.$bvToast.toast(`Informe o valor da operação da proposta. ;)`, {
            title: "Eiiii... Lembrando!",
            variant: "primary",
            autoHideDelay: 2000,
          });
          //this.$refs.approvedFinancingAmount.$el.focus();
          if (oldVal && !this.proposal.steps.contract.dueDate) {
            var today = new Date();
            var contractDate = moment(today).format("YYYY-MM-DD");
            this.proposal.steps.contract.dueDate = contractDate;
          }
        }
      } else {
        this.proposal.steps.contract.color = "light";
        this.proposal.steps.contract.note = "";
        this.proposal.steps.contract.progress = 0;
      }
    },
    "proposal.steps.contract.status"(newVal, oldVal) {
      if (newVal) {
        let situationArr = this.contractStatusOptions[
          this.proposal.steps.contract.situation
        ];
        situationArr.forEach((situation) => {
          if (situation.value === newVal) {
            if (situation.color)
              this.proposal.steps.contract.color = situation.color;
            if (situation.msg)
              this.proposal.steps.contract.note = situation.msg;
            if (situation.progress)
              this.proposal.steps.contract.progress = situation.progress;
          }
        });
        if (newVal === "Evoluída") {
          bootbox.alert({
            size: "small",
            message: "Please check Operation value",
          });
        }
      } else {
        for (let key in this.contractSituationOptions) {
          if (
            this.proposal.steps.contract.situation ===
            this.contractSituationOptions[key].value
          ) {
            this.proposal.steps.contract.color = this.contractSituationOptions[
              key
            ].color;
            this.proposal.steps.contract.note = this.contractSituationOptions[
              key
            ].msg;
            this.proposal.steps.contract.progress = this.contractSituationOptions[
              key
            ].progress;
          }
        }
      }
      if (
        this.proposal.steps.contract.situation ==
          "Em análise de conformidade" &&
        oldVal &&
        !this.proposal.steps.contract.dueDate
      ) {
        var today = new Date();
        var contractDate = moment(today).format("YYYY-MM-DD");
        this.proposal.steps.contract.dueDate = contractDate;
      }
    },

    "proposal.steps.riskAssessment.actived"(newVal) {
      if (newVal === false) {
        this.proposal.steps.riskAssessment["badgeColor"] = "light";
        this.proposal.steps.riskAssessment["color"] = "light";
        this.proposal.steps.riskAssessment["dueDate"] = "";
        this.proposal.steps.riskAssessment["note"] = "";
        this.proposal.steps.riskAssessment["situation"] = "";
        this.proposal.steps.riskAssessment["status"] = "";
        this.proposal.steps.riskAssessment["progress"] = 0;
      }
    },
    "proposal.steps.engineering.actived"(newVal) {
      if (newVal === false) {
        this.proposal.steps.engineering["badgeColor"] = "light";
        this.proposal.steps.engineering["color"] = "light";
        this.proposal.steps.engineering["dueDate"] = "";
        this.proposal.steps.engineering["note"] = "";
        this.proposal.steps.engineering["situation"] = "";
        this.proposal.steps.engineering["status"] = "";
        this.proposal.steps.engineering["progress"] = 0;
      }
    },
    "proposal.steps.forms.actived"(newVal) {
      if (newVal === false) {
        this.proposal.steps.forms["badgeColor"] = "light";
        this.proposal.steps.forms["color"] = "light";
        this.proposal.steps.forms["dueDate"] = "";
        this.proposal.steps.forms["note"] = "";
        this.proposal.steps.forms["situation"] = "";
        this.proposal.steps.forms["status"] = "";
        this.proposal.steps.forms["progress"] = 0;
      }
    },
    "proposal.steps.fgts.actived"(newVal) {
      if (newVal === false) {
        this.proposal.steps.fgts["badgeColor"] = "light";
        this.proposal.steps.fgts["color"] = "light";
        this.proposal.steps.fgts["dueDate"] = "";
        this.proposal.steps.fgts["note"] = "";
        this.proposal.steps.fgts["situation"] = "";
        this.proposal.steps.fgts["status"] = "";
        this.proposal.steps.fgts["progress"] = 0;
      }
    },
    "proposal.steps.dossier.actived"(newVal) {
      if (newVal === false) {
        this.proposal.steps.dossier["badgeColor"] = "light";
        this.proposal.steps.dossier["color"] = "light";
        this.proposal.steps.dossier["dueDate"] = "";
        this.proposal.steps.dossier["note"] = "";
        this.proposal.steps.dossier["situation"] = "";
        this.proposal.steps.dossier["status"] = "";
        this.proposal.steps.dossier["progress"] = 0;
      }
    },
    "proposal.steps.contract.actived"(newVal) {
      if (newVal === false) {
        this.proposal.steps.contract["badgeColor"] = "light";
        this.proposal.steps.contract["color"] = "light";
        this.proposal.steps.contract["dueDate"] = "";
        this.proposal.steps.contract["note"] = "";
        this.proposal.steps.contract["situation"] = "";
        this.proposal.steps.contract["status"] = "";
        this.proposal.steps.contract["progress"] = 0;
      }
    },
  },
};
</script>
